// Centralized authentication and sign-in messaging constants
export const AUTH_MESSAGES = {
  signInTitle: 'Sign in to Fact Check Trump',
  signInSubtitle:
    'Get our latest fact checks and exclusive insights by signing up! Unlock features like:',
  features: [
    {
      icon: 'check',
      text: 'Advanced search capabilities',
    },
    {
      icon: 'check',
      text: 'Detailed statistics and analytics',
    },
    {
      icon: 'check',
      text: 'Email updates on new fact checks',
    },
  ],
  termsText:
    "By signing in, you agree to Fact Check Trump's terms of service and privacy policy.",
  signInLoadingText: 'Signing in...',
  googleSignInError: 'An error occurred with Google sign-in. Please try again.',
  appleSignInError: 'An error occurred with Apple sign-in. Please try again.',
};
